import { gql } from "@apollo/client";

export const CREATE_EVALUACION_DATOS_PRINCIPALES = gql`
mutation CreateEvaluacionDatosPrincipales($input: AddContratoInput!) {
    createEvaluacionDatosPrincipales(input: $input){
        idEvaluacion
        idPaciente
    }
}
`;